
export default [{
    name: 'archives',
    path: '/archives',
    component: () => import ('@/views/archives'),
    children: [
        {
            name: 'P00',//委托协议
            path: '/xmgdViewFile',
            component: () => import ('@/views/pjfile/xmgdViewFile'),
            meta: {
                code: 'P00',
                title: '档案目录'
            },
        },
        {
            name: 'P01',//委托协议
            path: '/ptcViewFile',
            component: () => import ('@/views/pjfile/ptcViewFile'),
            meta: {
                code: 'P01',
            },
        },
        {
            name: 'P02',//项目基本信息
            path: '/proViewFile',
            component: () => import ('@/views/pjfile/proViewFile'),
            meta: {
                code: 'P02',
            },
        },
        {
            name: 'P03X',//项目公告
            path: '/pjnoticeFile',
            component: () => import ('@/views/pjfile/pjnoticeFile'),
            meta: {
                code: 'P03',
            },
            Ptype:'6'
        },
        {
            name: 'P04',//报名清单及报名文件
            path: '/psuIndexFile',
            component: () => import ('@/views/pjfile/psuIndexFile'),
            meta: {
                code: 'P04',
            },
        },
        {
            name: 'P05',//竞价/竞拍/比选过程记录
            path: '/biddingProFile',
            component: () => import ('@/views/pjfile/biddingProFile'),
            meta: {
                code: 'P05',
            },
        },
        {
            name: 'P06',//报价一览表
            path: '/biddingViewFile',
            component: () => import ('@/views/pjfile/biddingViewFile'),
            meta: {
                code: 'P06',
            },
        },
        {
            name: 'P07',//项目评比表
            path: '/projectReviewGcTabFile',
            component: () => import ('@/views/pjfile/projectReviewGcTabFile'),
            meta: {
                code: 'P07',
            },
        },
        {
            name: 'P08',//竞价/竞拍/比选报告
            path: '/projectReportFile',
            component: () => import ('@/views/pjfile/projectReportFile'),
            meta: {
                code: 'P08',
            },
        },
        {
            name: 'P09',//成交/采购失败确认函
            path: '/confirmLetterFile',
            component: () => import ('@/views/pjfile/confirmLetterFile'),
            meta: {
                code: 'P09',
            },
        },
        {
            name: 'P10C',//成交公告/采购失败公告
            path: '/pjnoticeFile',
            component: () => import ('@/views/pjfile/pjnoticeFile'),
            meta: {
                code: 'P10',
            },
            Ptype:'60'
        },
        {
            name: 'P11',//成交通知书
            path: '/pbidConfirmFile',
            component: () => import ('@/views/pjfile/pbidConfirmFile'),
            meta: {
                code: 'P11',
            },
        },
        {
            name: 'P12',//项目合同
            path: '/pjConFile',
            component: () => import ('@/views/pjfile/pjConFile'),
            meta: {
                code: 'P12',
            },
        },
        {
            name: 'P13Z',//终止公告
            path: '/pjnoticeFile',
            component: () => import ('@/views/pjfile/pjnoticeFile'),
            meta: {
                code: 'P13',
            },
            Ptype:'4'
        },
        {
            name: 'P14F',//废标公告
            path: '/pjnoticeFile',
            component: () => import ('@/views/pjfile/pjnoticeFile'),
            meta: {
                code: 'P14',
            },
            Ptype:'3'
        },
        {
            name: 'P15',//澄清公告
            path: '/announCList',
            component: () => import ('@/views/pjfile/announCList'),
            meta: {
                code: 'P15',
            },
            Ptype:'2'
        },
        {
            name: 'pjnoticeFile',//澄清公告
            path: '/pjnoticeFile',
            component: () => import ('@/views/pjfile/pjnoticeFile'),
            meta: {
                title: '澄清公告',
            }
        },
        {   
            name: 'psuBmFile',
            path: '/psuBmFile',
            component: () => import ('@/views/pjfile/psuBmFile'),
            meta: {
                title: '报名详情'
            }
        },
        {
            name: 'P16',//委托协议
            path: '/otherFile',
            component: () => import ('@/views/pjfile/otherFile'),
            meta: {
                code: 'P16',
                title: '其它附件'
            },
        },
    ]
}]
